const FactoryIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path
          d="M13 1.25001L7.95526 1.25C7.52244 1.24995 7.12561 1.24991 6.8028 1.29331C6.44732 1.3411 6.07159 1.45355 5.76257 1.76257C5.45355 2.07159 5.3411 2.44732 5.29331 2.8028C5.24991 3.12561 5.24995 3.52244 5.25 3.95526L5.25001 4.00001C5.25001 4.41422 5.58579 4.75001 6.00001 4.75001C6.41422 4.75001 6.75001 4.41422 6.75001 4.00001C6.75001 3.5074 6.7516 3.21339 6.77993 3.00267C6.78809 2.93443 6.84407 2.79434 7.00267 2.77993C7.21339 2.7516 7.5074 2.75001 8.00001 2.75001H13C13.4142 2.75001 13.75 2.41422 13.75 2.00001C13.75 1.58579 13.4142 1.25001 13 1.25001Z"
          fill="#0051FF"
        />
        <path
          d="M16 1.25C15.5858 1.25 15.25 1.58579 15.25 2C15.25 2.41421 15.5858 2.75 16 2.75H17C17.4142 2.75 17.75 2.41421 17.75 2C17.75 1.58579 17.4142 1.25 17 1.25H16Z"
          fill="#0051FF"
        />
        <path
          d="M10.25 5C10.25 4.58579 10.5858 4.25 11 4.25L17 4.25C17.4142 4.25 17.75 4.58579 17.75 5C17.75 5.41421 17.4142 5.75 17 5.75L11 5.75C10.5858 5.75 10.25 5.41421 10.25 5Z"
          fill="#0051FF"
        />
        <path
          d="M17.052 22.75L11.25 22.75V11.5364L12.0244 11.1493C12.5378 10.8925 12.9867 10.668 13.361 10.5373C13.7499 10.4014 14.2172 10.307 14.6898 10.5097C14.8492 10.5781 14.9976 10.6698 15.13 10.7818C15.5227 11.1138 15.6472 11.574 15.6996 11.9826C15.7122 12.0808 15.7217 12.1858 15.7288 12.2971L17.8212 11.2508C18.426 10.9484 18.9541 10.6843 19.391 10.5413C19.8507 10.3909 20.4013 10.3088 20.92 10.6294C21.4388 10.95 21.6115 11.4792 21.6826 11.9576C21.7501 12.4122 21.7501 13.0028 21.75 13.679L21.75 18.052C21.75 18.9505 21.7501 19.6997 21.6701 20.2944C21.5857 20.9222 21.4 21.489 20.9445 21.9445C20.4891 22.4 19.9223 22.5857 19.2945 22.6701C18.6997 22.75 17.9505 22.75 17.052 22.75Z"
          fill="#0051FF"
        />
      </g>
      <path
        d="M4.95526 6.25H7.04475C7.47757 6.24995 7.8744 6.24991 8.19721 6.29331C8.55269 6.3411 8.92842 6.45355 9.23744 6.76257C9.54647 7.07159 9.65891 7.44732 9.70671 7.8028C9.75011 8.12561 9.75006 8.52245 9.75001 8.95526L9.75001 9.25H2.25L2.25 8.95526C2.24995 8.52244 2.24991 8.12561 2.29331 7.8028C2.3411 7.44732 2.45355 7.07159 2.76257 6.76257C3.07159 6.45355 3.44732 6.3411 3.8028 6.29331C4.12561 6.24991 4.52244 6.24995 4.95526 6.25Z"
        fill="#0051FF"
      />
      <path
        d="M2.25 10.75H9.75V22C9.75 22.4142 9.41422 22.75 9 22.75L6.94801 22.75C6.04953 22.75 5.30031 22.7501 4.70552 22.6701C4.07773 22.5857 3.51093 22.4 3.05546 21.9445C2.59999 21.4891 2.41432 20.9223 2.32991 20.2945C2.24995 19.6997 2.24997 18.9505 2.25 18.052L2.25 10.75Z"
        fill="#0051FF"
      />
    </svg>
  );
};

export default FactoryIcon;
